import { render, staticRenderFns } from "./fccConfiguracaoDaPublicacao.vue?vue&type=template&id=4871968e"
import script from "./fccConfiguracaoDaPublicacao.vue?vue&type=script&lang=js"
export * from "./fccConfiguracaoDaPublicacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports